import { graphql } from 'gatsby';

import { renderCareersOverview } from '../../templates/careers';

import CONTENT from '../../static-content/careers.json';
import { EN_AU } from '../../utils/geo-space-id-helpers';


/**
 * The careers overview page
 *
 * @component
 */
const CareersOverview = props => {
  const { data } = props;   

  return (
    renderCareersOverview(data, CONTENT, EN_AU)
  );
};

export default CareersOverview;

export const careersPageQuery = graphql`
  query CareersPageQuery($globalSpaceId: String!) {
    careersHeroImage: file(relativePath: { eq: "photography/careers/overview/careers-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 1200)
      }
    }
    lifeAtCrederaImage: file(relativePath: { eq: "photography/careers/overview/careers-life-at-credera.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
    elevatedContentImage: file(relativePath: { eq: "photography/careers/overview/gabriel-greening-careers.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
    carouselVideos: contentfulSectionContentVideoCarousel(spaceId: { eq: $globalSpaceId }, id: { eq: "106acdee-5197-52be-9558-0d34e83372a8" }) {
      ...SectionContentVideoCarousel
    }
    ourCulture: file(relativePath: { eq: "photography/careers/overview/our-culture-apac.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED)
      }
    }
    awards: contentfulSectionContentGrid(spaceId: { eq: $globalSpaceId }, id: { eq: "5f233a18-928d-548e-b48a-cbea5871da04" }) {
      ...SectionContentGrid
    }
    globalOffices: contentfulCarousel(spaceId: { eq: $globalSpaceId }, id: { eq: "da8883d9-959b-5264-87c0-93b2339136cb" }) {
      carouselItems {
        ...NoContentOffice
      }
    }
  }
`;